/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import { Achievement, AchievementDTO } from '@ai-platform/utils';

export const transformAchievementDtoToModel = (dto: AchievementDTO): Achievement => {
    const { id, title, description, text, enabled, owned, background_image_url, achievement_image_url } = dto;

    return {
        id,
        title,
        description,
        text,
        enabled,
        owned,
        imageData: {
            backgroundImageUrl: background_image_url.replace('/orig', '/optimize'),
            achievementImageUrl: achievement_image_url.replace('/orig', '/optimize'),
        },
    };
};
